import * as React from "react";

import "./shipping-modules.scss";

import {to_isAddressable} from "@Common/logic/template-options/template-options-is-addressable";
import {cs}               from "@Common/react/chain-services";
import {formatMoney1}     from "@Common/ui-components/language/format-money";
import {formatNumberBig}  from "@Common/ui-components/language/format-number-big";
import {SliderCheckbox}   from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {chain}            from "@Common/utils/fs";

import {getPurchaseMlSummaryLines}  from "@Xpresso/routes/common/address-lists/get-purchase-ml-summary-lines";
import {AddressableShippingOptions} from "@Xpresso/routes/common/heavy/addressable-shipping-options/addressable-shipping-options";

import {groupEnrollmentEditors}             from "../../../../common/group-enrollment-editors";
import {enrollmentEditor, summaryLines, ui} from "../common/expo-types";

import {ScBulkMailPermitLogic}            from "./sc-bulk-mail-permit-logic";
import {ScEnableAddressableShippingLogic} from "./sc-enable-addressable-shipping-logic";
import {ScIntelligentMailBarcode}         from "./sc-intelligent-mail-barcode";
import {ScShippingQuantity}               from "./sc-shipping-quantity";

export const ShippingModules = ({initEnrollment, templateOptions, agentId}) => [
    {
        load: ({method, shippingAddress1, shippingServiceLevel1}, next) => next(
            method === "shipping" && {
                enrollmentEditor: groupEnrollmentEditors([
                    shippingAddress1.enrollmentEditor,
                    shippingServiceLevel1.enrollmentEditor,
                ]),
                ui: ({showErrors}) => (
                    <div className="shipping-modules-56q section">

                        <div className="header">
                            <div {...{
                                className: "title",

                                "xd-qa-type": "label",
                                "xd-qa-name": "Shipping",
                            }}>
                                Shipping
                            </div>
                            <div {...{
                                className: "subtitle",
                                "xd-qa-type": "text",
                                "xd-qa-name": "Shipping Description",
                            }}>
                                Select delivery address, service level and set up your preferences
                            </div>
                        </div>
                        <div className="box">
                            {shippingAddress1.render({showErrors})}

                            {shippingServiceLevel1.render({showErrors})}
                        </div>
                    </div>
                ),
            }
        ),
        expo: [ui(1), enrollmentEditor],
        requires: ["method", "shippingAddress1", "shippingServiceLevel1"],
    },


    {
        name: "enableAddressableShippingLogic1",
        load: ({method}, next) => cs(
            ["module", (_, next) => ScEnableAddressableShippingLogic({initEnrollment, next})],
            ({module}) => next(
                method === "shipping" && (!templateOptions || to_isAddressable(templateOptions)) ? (
                    module
                ) : (
                    null
                )
            ),
        ),
        requires: ["method"],
        expo: [enrollmentEditor],
    },

    {
        name: "shippingQuantity1",
        load: ({method, enableAddressableShippingLogic1}, next) => ScShippingQuantity({
            initEnrollment,
            enabled: method === "shipping" && !enableAddressableShippingLogic1?.state.value,
            next,
        }),
        requires: ["method", "enableAddressableShippingLogic1"],
    },
    {
        name: "shippingQuantity2",
        load: ({shippingQuantity1, shippingPaperPrices, shippingPaperPrice}, next) => shippingQuantity1.next({
            paperPrices: shippingPaperPrices, paperPrice: shippingPaperPrice,
            next,
        }),
        expo: [enrollmentEditor],
        requires: ["shippingQuantity1", "shippingPaperPrices", "shippingPaperPrice"],
    },

    {
        load: ({method, enableAddressableShippingLogic1, shippingQuantity2}, next) => next(
            method === "shipping" && {
                // enrollmentEditor: groupEnrollmentEditors([
                //     shippingAddress1.enrollmentEditor,
                //     shippingServiceLevel1.enrollmentEditor,
                // ]),
                ui: ({showErrors}) => (
                    <div className="shipping-modules-56q section print-address">

                        <div className="header">
                            <div {...{
                                className: "title",

                                "xd-qa-type": "label",
                                "xd-qa-name": "Print Addresses",
                            }}>
                                Print Addresses
                            </div>
                        </div>
                        <div className="box">
                            {AddressableShippingOptions({
                                state: enableAddressableShippingLogic1?.state,
                                subSections: [
                                    shippingQuantity2.ui && (
                                        <div className="section">
                                            {shippingQuantity2.ui({showErrors})}
                                        </div>
                                    )
                                ].filter(v=>v),
                            })}
                        </div>
                    </div>
                ),
            }
        ),
        expo: [ui(2, {hasSpacer: true}), enrollmentEditor],
        requires: ["method", "enableAddressableShippingLogic1", "shippingQuantity2"],
    },

    {
        load: ({method, enableAddressableShippingLogic1, addressLists2, renderAddressLists}, next) => next(
            method === "shipping" && enableAddressableShippingLogic1?.state.value && {
                enrollmentEditor: addressLists2.enrollmentEditor,
                ui: ({showErrors}) => (
                    <div className="shipping-modules-56q section">

                        <div className="header">
                            <div {...{
                                className: "title",

                                "xd-qa-type": "label",
                                "xd-qa-name": "Mailing List(s)",
                            }}>
                                Mailing List(s)
                            </div>
                            <div {...{
                                className: "subtitle",

                                "xd-qa-type": "text",
                                "xd-qa-name": "Mailing List description",
                            }}>
                                Select mailing list(s) to print on shipped order
                            </div>
                        </div>
                        <div className="box">
                            {renderAddressLists({
                                className: "shipping-modules-56q address-lists",
                                showErrors,
                            })}
                        </div>
                    </div>
                ),
            }
        ),
        expo: [ui(3, {hasSpacer: true}), enrollmentEditor],
        requires: ["method", "enableAddressableShippingLogic1", "addressLists2", "renderAddressLists"],
    },

    {
        name: "bulkMailPermit",
        load: ({}, next) => ScBulkMailPermitLogic({
            agentId,
            templateOptions,
            initEnrollment,
            next,
        }),
        // expo: [enrollmentEditor,],
        requires: [],
    },

    {
        load: ({method, bulkMailPermit, enableAddressableShippingLogic1, unaddressedCopiesLogic}, next) => next(
            bulkMailPermit && (
                method === "shipping" && enableAddressableShippingLogic1?.state.value ||
                method === "mailing" && unaddressedCopiesLogic?.state.value
            ) && {
                enrollmentEditor: bulkMailPermit.enrollmentEditor,
                ui: ({showErrors}) => (
                    <div className="shipping-modules-56q section">

                        <div className="header">
                            <div {...{
                                className: "title",

                                "xd-qa-type": "label",
                                "xd-qa-name": "Use Bulk Mail Permit",
                            }}>
                                Use Bulk Mail Permit
                            </div>

                            {SliderCheckbox({
                                ...bulkMailPermit.ui.selected,
                                xdQaName: "Use Bulk Mail Permit",
                            })}
                        </div>
                        <div className="box">
                            {bulkMailPermit.ui.render({showErrors})}
                        </div>
                    </div>
                ),
            }
        ),
        expo: [ui(4, {hasSpacer: true}), enrollmentEditor], // no need enrollmentEditor
        requires: ["method", "bulkMailPermit", "enableAddressableShippingLogic1", "unaddressedCopiesLogic"],
    },


    {
        name: "imb",
        load: ({}, next) => ScIntelligentMailBarcode({
            agentId,
            templateOptions,
            initEnrollment,
            next,
        }),
        // expo: [enrollmentEditor,],
        requires: [],
    },
    {
        load: ({method, imb, enableAddressableShippingLogic1}, next) => next(
            method === "shipping" && imb && enableAddressableShippingLogic1?.state.value && {
                enrollmentEditor: imb.enrollmentEditor,
                ui: ({showErrors}) => (
                    <div className="shipping-modules-56q section">

                        <div className="header">
                            <div {...{
                                className: "title",

                                "xd-qa-type": "label",
                                "xd-qa-name": "Use Intelligent Mail Barcode (IMb)",
                            }}>
                                Use Intelligent Mail Barcode (IMb)
                            </div>
                            {SliderCheckbox({...imb.ui.selected, xdQaName: imb.ui.selected.value ? "Use Intelligent Mail Barcode Slider true" : "Use Intelligent Mail Barcode Slider false"})}
                        </div>

                        {imb.ui.selected.value && (
                            imb.ui.render({showErrors})
                        )}

                    </div>
                ),
            }
        ),
        expo: [ui(5, {hasSpacer: true}), enrollmentEditor],
        requires: ["method", "imb", "enableAddressableShippingLogic1"],
    },

    {
        load: (
            {
                method, shippingAddress1, shippingServiceLevel1, addressLists1, mailingLists,
                enableAddressableShippingLogic1,
                shippedQuantity, getShippingPaperPrice,
            },
            next
        ) => next(method === "shipping" && (({templateOptionsList}) => [
            {
                name: "Delivery Method",
                value: "Shipped",
            },
            {
                name: "Service Level",
                value: shippingServiceLevel1.serviceLevelLabel,
            },
            {
                name: "Mailing List(s)",
                value: enableAddressableShippingLogic1?.state.value ? (
                    addressLists1.state.value?.map((id) => mailingLists.value?.find((ml) => ml.id == id)?.mailingListName).join(", ")
                ) : (
                    "N/A"
                ),
            },
            {
                name: "Shipping Address",
                // {address.address1}, {address.city} {address.state} {address.postalCode}
                value: shippingAddress1.address && chain(
                    shippingAddress1.address,
                    (_) => `${_.address1}, ${_.city} ${_.state} ${_.postalCode}`,
                ),
            },
            // bulkMailPermit && enableAddressableShippingLogic1?.state.value && {
            //     name: "Use Bulk Mail Permit",
            //     value: bulkMailPermit.ui.selected.value ? "Yes" : "No",
            // },
            // imb && enableAddressableShippingLogic1?.state.value && {
            //     name: "Use Intelligent Mail Barcode (IMb)",
            //     value: imb.ui.selected.value ? "Yes" : "No",
            // },

            {
                name: "Quantity per Edition",
                value: formatNumberBig(shippedQuantity) + " (Shipped)",
            },
            // ...templateOptionsList?.map((templateOptions) => {
            //     const shippingPaperPrice = getShippingPaperPrice(templateOptions);
            //     return ({
            //         name: `Price per Piece (${templateOptions?.product.name})`,
            //         value: fragments(!shippingPaperPrice ? "--" : formatMoney1(shippingPaperPrice.price), ` (Shipped)`),
            //     });
            // })??[],

            ...getPurchaseMlSummaryLines({
                templateOptions,
                mailingLists: addressLists1.state.value?.map((id) => mailingLists.value?.find((ml) => ml.id == id)).filter(v=>v),
                isMailing: false,
            })
                .map(({label, qty, unitPrice})=> ({
                    name: <>{label} ({formatMoney1(unitPrice)} each)</>,
                    value: formatMoney1(unitPrice*qty),
                }))
            ,
        ].filter(v=>v))),
        requires: [
            "method", "shippingAddress1", "shippingServiceLevel1", "addressLists1", "mailingLists",
            "enableAddressableShippingLogic1",
            "shippedQuantity", "getShippingPaperPrice"
            // , "bulkMailPermit", "imb"
        ],
        expo: [summaryLines],
    },

];
